<template>
    <div>
        <v-text-field
                v-model="equipment"
                :label="label|translate"
                class="cursor-as-pointer"
                readonly
                :disabled="disabled"
                v-on:click="openDiag()"
                :clearable="clearable"
        >
                <template v-slot:append>
                    <v-icon v-on:click="openDiag()" class="cursor-as-pointer">fa-caret-down</v-icon>
                </template>
        </v-text-field>
        <v-dialog
                v-model="dialog"
                width="500"
        >
            <v-card>
                <v-sheet class="pa-3 primary lighten-2">
                    <v-text-field
                            v-model="search"
                            :label="'Search'|translate"
                            flat
                            solo-inverted
                            hide-details
                            clearable
                    ></v-text-field>
                </v-sheet>
                <v-card-text>
                    <v-treeview v-if="equipTree"
                                :search="search"
                                :items="equipTree"
                                activatable
                                item-key="id"
                                :open.sync="open"
                                open-on-click
                    >
                        <template v-slot:label="{ item }">
                            <span v-if="!floorMode&&item.children.length===0" v-on:click="selectItem(item)">{{item.name}}</span>
                            <span v-if="!floorMode&&item.children.length>0">{{item.name}}</span>
                            <span v-if="floorMode&&item.children.length===0">{{item.name}}</span>
                            <span v-if="floorMode&&item.children.length>0"  v-on:click="selectFloor(item)">{{item.name}}</span>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>

        </v-dialog>

    </div>
</template>

<script>
    import {sortFloors} from '@/helper'
  export default {
    name: 'EquipmentSelector',
    props: {
      value: String,
      typeFilter: {type: String, default: null},
      label: {type: String, default: "Equipment Name"},
      clearable: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
        floorMode: {type: Boolean, default: false},
    },
    watch: {
      value () {
        if(this.equipment!==this.value){
          this.equipment = this.value
        }
      },
      equipment (newEquipment) {
        this.$emit('input', newEquipment)
        this.$emit('ect', this.typeMap[newEquipment])
      },
      selectEquip (newSelectEquip) {
        if (!this.equipment) {
          this.equipment = newSelectEquip[0].equipment_name
        }
      }
    },
    data () {
      return {
        equipment: null,
          search:null,
          dialog:false,
          open:[],
          typeMap:{}
      }
    },
      methods: {
        selectItem(item){
            this.equipment=item.name
            this.dialog=false;
        },
          selectFloor(item){
              this.equipment=item.floor
              this.dialog=false;
          },
          openDiag() {
            if(!this.disabled) {
                this.search = null
                this.open = [];
                this.dialog = true
            }
          },
          findWhere(array, key, value) {
              let t = 0;
              while (t < array.length && array[t][key] !== value) {
                  t++;
              }
              if (t < array.length) {
                  return array[t]
              } else {
                  return false;
              }
          },
          arrangeIntoTree(paths) {
              let tree = [];
              for (let i = 0; i < paths.length; i++) {
                  let path = paths[i];
                  let currentLevel = tree;
                  for (let j = 0; j < path.length; j++) {
                      let part = path[j];
                      let existingPath = this.findWhere(currentLevel, 'name', part);
                      if (existingPath) {
                          currentLevel = existingPath.children;
                      } else {
                          let newPart = {
                              name: part,
                              id: path.join('-')+'-'+part,
                              floor:path.slice(0, j+1).join('>'),
                              children: [],
                          }
                          currentLevel.push(newPart);
                          currentLevel = newPart.children;
                      }
                  }
              }
              return tree;
          }
      },
    mounted () {
      if (!!this.value) {
        this.equipment = this.value
      }
      if (!this.equipment) {
        this.equipment = this.selectEquip[0].equipment_name
      }
        for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
            let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
            this.typeMap[equip.equipment_name] = equip.equipment_type;
        }
    },
      computed: {
      selectEquip() {
        if (!this.$store.state.pointsListStore.pointsList) return [{id: 1, name: 'loading'}]
        let output = []
        for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
          if (!!this.typeFilter){
              let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
              if(this.typeFilter.includes(',')){
                  let splited=this.typeFilter.split(',');
                  for(let value of splited){
                      if (equip.equipment_type.toLowerCase()==value.toLowerCase()){
                          output.push(equip)     // push to array if matching filter
                          break
                      }
                  }
              } else if(this.typeFilter.includes('*')) {
                  let nonstar=this.typeFilter.replace("*","");
                  if(equip.equipment_type.toLowerCase().includes(nonstar.toLowerCase())) {
                      output.push(equip)
                  }
              } else {
                      if (equip.equipment_type.toLowerCase()==this.typeFilter.toLowerCase()){
                          output.push(equip)               // push to array if matching filter
                      }
              }


          } else {
            output.push(this.$store.state.pointsListStore.pointsList.equipment_details[i]) // push to array if no filter
          }

        }
        output.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
        return output
      },
      equipTree(){
          let equipList=this.selectEquip;
          let equipPaths=[];
          for (let equip of equipList){
            if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                equipPaths.push(equip.floor.split('>').concat([equip.equipment_name]))
            } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                equipPaths.push([equip.equipment_type,equip.equipment_name])
            } else {
                equipPaths.push([equip.equipment_name])
            }
          }
          equipPaths=sortFloors(equipPaths)
          let tree=this.arrangeIntoTree(equipPaths);
          return tree;
      }
    }
  }
</script>

<style scoped>
    .cursor-as-pointer{
        cursor: pointer;
    }
</style>
